import operationAccountService from "@/services/operations/operationAccountService";
import operationLocalDbService from "@/services/operations/operationLocalDbService";
import mapKeys from "lodash/mapKeys";

const INITIAL_STATE = {
  operationEnterpriseAccounts: [
    // {
    //   "account": {
    //     "created_at": "2024-03-22T11:45:44.545Z",
    //     "expired_at": "2024-03-22T11:45:44.545Z",
    //     "id": "string",
    //     "last_logined_at": "2024-03-22T11:45:44.545Z",
    //     "login_key": "string",
    //     "os": "string",
    //     "role_name": "string",
    //     "user_agent": "string"
    //   },
    //   "created_at": "2024-03-22T11:45:44.545Z",
    //   "deleted_at": "2024-03-22T11:45:44.545Z",
    //   "enterprise_account_id": "string",
    //   "free": true,
    //   "profile": {
    //     "department": "string",
    //     "email_address": "string",
    //     "name": "string",
    //     "name_kana": "string",
    //     "phone_number": "string",
    //     "picture": {
    //       "id": "string",
    //       "original_path": "string",
    //       "thumbnail_path": "string"
    //     },
    //     "title": "string"
    //   },
    //   "updated_at": "2024-03-22T11:45:44.545Z"
    // }
  ],
};

export default {
  isRegistered: false,
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  mutations: {
    /**
     * operation account 設定をセットするミューテーション
     *
     * @param {Object} state - Vuex ストアの状態オブジェクト
     * @param {OperationAccount[]} data - データ
     * @returns {void}
     */
    SET_OPERATION_ENTERPRISE_ACCOUNTS(state, data) {
      state.operationEnterpriseAccounts = data;
    },

    RESET_STATE(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },
  actions: {
    /**
     * operation account 設定 を storeにセットする
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationAccounts({ commit }) {
      const response = await operationAccountService.getOperationAccounts();
      const operationEnterpriseAccounts = response.data || [];
      commit("SET_OPERATION_ENTERPRISE_ACCOUNTS", operationEnterpriseAccounts);
      operationLocalDbService.setOperationAccountsToLocalDB(
        operationEnterpriseAccounts
      );
    },

    /**
     * operation account  を localDB から取得し storeにセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationAccountsFromLocalDB({ commit }) {
      const operationAccounts = await operationLocalDbService.getOperationAccountsFromLocalDB();
      commit("SET_OPERATION_ENTERPRISE_ACCOUNTS", operationAccounts || []);
    },

    /**
     * operation account  を localDB から取得し storeにセットする
     * localDBにない場合はAPIから取得し store にセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationAccountsFromLocalDBAndAPI({ dispatch, getters }) {
      await dispatch("setOperationAccountsFromLocalDB");
      if (!getters.hasOperationEnterpriseAccount) {
        dispatch("setOperationAccounts");
      }
    },

    /**
     * storeを初期値に戻す
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     */
    async resetState({ commit }) {
      commit("RESET_STATE");
    },
  },
  getters: {
    // OperationEnterpriseAccount[]
    validOperationEnterpriseAccounts({ operationEnterpriseAccounts }) {
      if (!Array.isArray(operationEnterpriseAccounts)) return [];
      return operationEnterpriseAccounts.filter(oa =>
        operationAccountService.isOperationEnterpriseAccount(oa)
      );
    },

    // レポート一覧で検索可能な担当者一覧
    // OperationEnterpriseAccount[]
    reportSearchableOperationEnterpriseAccounts(
      _,
      {
        validOperationEnterpriseAccounts, // OperationEnterpriseAccount[]
      }
    ) {
      return validOperationEnterpriseAccounts.filter(oa =>
        operationAccountService.isEnableToReportSearch(oa)
      );
    },

    // {[key: AccountId]: OperationEnterpriseAccount}
    reportSearchableOperationEnterpriseAccountMapByAccountId(
      _,
      {
        reportSearchableOperationEnterpriseAccounts, // OperationEnterpriseAccount[]
      }
    ) {
      const oEAs = reportSearchableOperationEnterpriseAccounts;
      if (!Array.isArray(oEAs)) return {};
      return mapKeys(oEAs, "account.id");
    },

    hasOperationEnterpriseAccount: (
      _,
      { validOperationEnterpriseAccounts }
    ) => {
      return validOperationEnterpriseAccounts.length > 0;
    },
  },
};
